import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col gap-4 rounded-lg border border-background-300 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row"
    >
      <div className="h-40 w-full shrink-0 overflow-hidden rounded-md sm:h-28 sm:w-44">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 我的朋友他的妻子最新动态`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <i className="ri-calendar-line"></i>
          {item.date}
        </div>
        <h3 className="mt-2 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
          阅读全文
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </span>
      </div>
    </Link>
  );
}